import cn from 'classnames';

type IProductPictureMaskProps = {
    text?:string;
};

export const Mask: Globals.FC<IProductPictureMaskProps> = props => {
    const { text='Sold Out', className, ...rest } = props;

    return (
        <div
            className={cn('g-mask', className)}
            {...rest}
    >
            {text}
        </div>
    )
};